module.exports = __webpack_public_path__ + "static/media/bakcell.c13abcf2.svg";